import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const ORDEM = ['start', 'speed', 'turbo', 'full_speed'];
export const ROTULO_PLANO = { start: 'Start', speed: 'Speed', turbo: 'Turbo', full_speed: 'Full Speed' };

// Recursos que dependem do plano — espelha backend/services/planos/planos.service.js
// (o servidor é quem realmente bloqueia; aqui é só pra esconder/desabilitar o botão).
const PLANO_MINIMO = { fiscal: 'full_speed' };

const chaveCache = (id) => `plano_atual_${id}`;

function lerCache(id) {
  try { return localStorage.getItem(chaveCache(id)); } catch { return null; }
}

export function planoTemRecurso(plano, recurso) {
  return ORDEM.indexOf(plano) >= ORDEM.indexOf(PLANO_MINIMO[recurso]);
}

// Plano do estabelecimento selecionado. Começa pelo último valor conhecido
// (cache local, pra o menu não "piscar" liberado) e confirma com o servidor.
// Enquanto não souber (primeira visita), `plano` é null e nada é bloqueado
// visualmente — o servidor continua barrando de qualquer jeito.
export default function usePlano() {
  const id = localStorage.getItem('estabelecimento_id');
  const [plano, setPlano] = useState(() => (id ? lerCache(id) : null));

  useEffect(() => {
    if (!id) return undefined;
    let vivo = true;
    fetch(`${API_URL}/estabelecimentos`, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : []))
      .then((lista) => {
        const est = lista.find((e) => e.id_estabelecimento === Number(id));
        if (!est || !vivo) return;
        const atual = est.plano_atual || 'start';
        setPlano(atual);
        try { localStorage.setItem(chaveCache(id), atual); } catch { /* sem cache */ }
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, [id]);

  return {
    plano,
    carregado: plano !== null,
    temRecurso: (recurso) => plano === null || planoTemRecurso(plano, recurso)
  };
}
